"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExpandingCardMode;
(function (ExpandingCardMode) {
    /**
     * To have top compact card only
     */
    ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
    /**
     * To have both top compact and bottom expanded card
     */
    ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
})(ExpandingCardMode = exports.ExpandingCardMode || (exports.ExpandingCardMode = {}));
var OpenCardMode;
(function (OpenCardMode) {
    /**
     * Open card by hover
     */
    OpenCardMode[OpenCardMode["hover"] = 0] = "hover";
    /**
     * Open card by hot key
     */
    OpenCardMode[OpenCardMode["hotKey"] = 1] = "hotKey";
})(OpenCardMode = exports.OpenCardMode || (exports.OpenCardMode = {}));
//# sourceMappingURL=ExpandingCard.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/HoverCard/ExpandingCard.types.js
// module id = 400
// module chunks = 0